import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { COLORS } from "constants/colors";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      backgroundColor: "rgba(64, 180, 229, 0.25)",
      flexDirection: "row",
      height: "52px",
      width: "140px",
      "&:hover": {
        background: "rgba(64, 180, 229, 0.25)",
      },
      [theme.breakpoints.down("xs")]: {
        height: "38px",
        width: "116px",
      },
    },
    buttonGroup: {
      boxShadow: "none",
    },
    filterStyle: {
      color: COLORS.primary,
      fontFamily: "Montserrat",
      fontWeight: "bold",
      width: 100,
    },
    optionStyle: {
      color: COLORS.primary,
      fontFamily: "Montserrat",
      width: 150.5,
    },
  })
);
